import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

const MESSAGES = [
  "Computing planetary positions…",
  "Mapping your chart…",
  "Reading your chapters…",
  "Finding your resonance…",
  "Preparing your journey…",
];

export default function RevealLoading() {
  const navigate = useNavigate();
  const [msgIdx, setMsgIdx] = useState(0);
  const [error, setError] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => setMsgIdx(i => (i + 1) % MESSAGES.length), 2200);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    (async () => {
      try {
        await api.post("/reveal/generate");
        // Navigate immediately — no artificial pacing delay.
        navigate("/reveal/life-map", { replace: true });
      } catch (e) {
        console.error(e);
        setError("Something went quiet. Please try again.");
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-8 constellation-bg" style={{ color: "var(--vedari-ink)" }}>
      <div className="relative w-32 h-32 mb-12">
        <div className="absolute inset-0 rounded-full animate-glow-pulse" style={{ border: "1px solid var(--vedari-gold)" }} />
        <div className="absolute inset-3 rounded-full animate-slow-spin" style={{ border: "1px dashed rgba(184,149,74,0.5)" }} />
        <div className="absolute inset-0 flex items-center justify-center font-display text-4xl" style={{ color: "var(--vedari-gold)" }}>व</div>
      </div>

      <p className="text-body-lg font-serif animate-soft-pulse text-center max-w-xs" data-testid="loading-message" style={{ color: "var(--vedari-ink)" }}>
        {error || MESSAGES[msgIdx]}
      </p>
      {error && (
        <button onClick={() => window.location.reload()} className="vedari-btn-secondary mt-8" data-testid="loading-retry-btn">Try again</button>
      )}
    </div>
  );
}
